export const validation = values => {
  const errors = {};

  if (!values.noteExecutionText) {
    errors.noteExecutionText = 'Required';
  }

  return errors;
};
